import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { firebaseConnect, isEmpty } from 'react-redux-firebase';
import FacebookIcon from 'react-icons/lib/fa/facebook';
import GoogleIcon from 'react-icons/lib/fa/google';
import Notifications from 'react-notification-system-redux';
import { Link } from 'react-router-dom';
import { push as pushActions } from 'react-router-redux';
import Formsy from 'formsy-react';
import Styles from './styles';
import CenteredWrapper from '../../components/CenteredWrapper';
import JumperButton from '../../components/UIKit/Button';
import FormsyJumperInput from '../../components/Formsy/Input';
import Spacer from '../../components/Spacer';
import Footer from '../../components/Footer';
import logoImg from '../../assets/images/login-logo.png';

class Login extends Component {
  constructor() {
    super();

    this.state = {
      nextRoute: '/projects',
    };

    this.googleLogin = this.googleLogin.bind(this);
    this.facebookLogin = this.facebookLogin.bind(this);
    this.onValidLoginFormSubmit = this.onValidLoginFormSubmit.bind(this);
    this.onInvalidLoginFormSubmit = this.onInvalidLoginFormSubmit.bind(this);
  }

  componentWillMount() {
    const { location, auth, push } = this.props;

    if (!isEmpty(auth)) {
      push(this.state.nextRoute);
    }

    if (location.state && location.state.from && location.state.from.pathname) {
      this.setState({
        nextRoute: location.state.from.pathname,
      });
    }

    if (!isEmpty(auth)) {
      push(this.state.nextRoute);
    }
  }

  componentWillUpdate(nextProps) {
    const { push } = this.props;

    if (!isEmpty(nextProps.auth)) {
      push(this.state.nextRoute);
    }
  }

  onValidLoginFormSubmit({ email, password }) {
    const { firebase, showNotification, authError } = this.props;

    return firebase.login({ email, password }).catch(() => {
      showNotification(
        Notifications.error({
          uid: authError.code,
          message: authError.message,
          position: 'bc',
          autoDismiss: 0,
        }),
      );
    });
  }

  onInvalidLoginFormSubmit() {
    this.props.showNotification(
      Notifications.error({
        message: 'The form contains errors. Please correct them before submitting again',
        position: 'bc',
        autoDismiss: 3,
      }),
    );
  }

  facebookLogin() {
    const { firebase, showNotification, authError } = this.props;

    this.setState({ isLoading: true });

    return firebase.login({ provider: 'facebook', type: 'popup' }).catch(() => {
      showNotification(
        Notifications.error({
          uid: authError.code,
          message: authError.message,
          position: 'bc',
          autoDismiss: 0,
        }),
      );
    });
  }

  googleLogin() {
    const { firebase, showNotification, authError } = this.props;

    return firebase.login({ provider: 'google', type: 'popup' }).catch(() => {
      showNotification(
        Notifications.error({
          uid: authError.code,
          message: authError.message,
          position: 'bc',
          autoDismiss: 0,
        }),
      );
    });
  }

  render() {
    const forgotPassword = (
      <div style={Styles.forgotPasswordWrapper}>
        <Link style={Styles.forgotPassword} to="/password-forgot">
          Forgot your password?
        </Link>
      </div>
    );

    const footerLinkStyle = { color: '#476166', fontSize: 10, margin: 10 };
    const loginButtonStyle = {
      minWidth: 'inherit',
      background: 'white',
      margin: 15,
      width: 30,
      height: 30,
    };
    const formStyle = { width: '100%' };
    const dontHaveAccountPStyle = { textAlign: 'center', color: 'white', fontSize: 10 };

    const emailValidations = {
      isEmail: true,
      maxLength: 50,
    };
    const emailValidationErrors = {
      isEmail: 'You have to type valid email',
      maxLength: 'You can not type in more than 50 characters',
    };

    return (
      <div style={Styles.wrapper}>
        <Spacer />
        <CenteredWrapper align="center" width={250}>
          <img alt="Logo" style={Styles.logo} src={logoImg} />
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <JumperButton onClick={this.googleLogin} size="sm" style={loginButtonStyle}>
              <GoogleIcon size={20} style={Styles.socialLogin} />
            </JumperButton>
            <JumperButton onClick={this.facebookLogin} size="sm" style={loginButtonStyle}>
              <FacebookIcon size={20} style={Styles.socialLogin} />
            </JumperButton>
          </div>
          <Formsy
            onValidSubmit={this.onValidLoginFormSubmit}
            onInvalidSubmit={this.onInvalidLoginFormSubmit}
            style={formStyle}
          >
            <FormsyJumperInput
              name="email"
              required
              placeholder="e-mail address"
              validations={emailValidations}
              validationErrors={emailValidationErrors}
            />
            <FormsyJumperInput
              name="password"
              required
              placeholder="password"
              type="password"
              extra={forgotPassword}
            />
            <JumperButton formNoValidate type="none">
              LOG IN
            </JumperButton>
            <p style={dontHaveAccountPStyle}>
              {"Don't have an account yet?"}
              <br />
              <Link to="/register">Register</Link>
            </p>
          </Formsy>
        </CenteredWrapper>
        <Spacer />
        <Footer>
          <a href="/dommy-link" style={footerLinkStyle}>
            Link
          </a>
          <a href="/dommy-link" style={footerLinkStyle}>
            Link
          </a>
          <a href="/dommy-link" style={footerLinkStyle}>
            Link
          </a>
          <a slot="right" href="/dommy-link" style={footerLinkStyle}>
            Terms and conditions
          </a>
        </Footer>
      </div>
    );
  }
}

Login.propTypes = {
  firebase: PropTypes.objectOf(PropTypes.func).isRequired,
  push: PropTypes.func.isRequired,
  showNotification: PropTypes.func.isRequired,
  authError: PropTypes.objectOf(PropTypes.any).isRequired,
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  auth: PropTypes.objectOf(PropTypes.any).isRequired,
};

const mapStateToProps = ({ firebase: { auth, authError }, router: { location } }) => ({
  auth,
  authError,
  location,
});

const mapDispatchToProps = dispatch => ({
  showNotification: (notification) => {
    dispatch(notification);
  },
  push: (path) => {
    dispatch(pushActions(path));
  },
});

export default compose(firebaseConnect(), connect(mapStateToProps, mapDispatchToProps))(Login);



// WEBPACK FOOTER //
// ./src/containers/Login/index.js